@if (!isLoading) {
  <div appAutoAudit [auditData]="fieldAuditData" [auditDisabled]="!!snapshotData">
  <div class="form-title-container">
    <h3>Aplicaciones</h3>
  </div>
  <form
    [formGroup]="fixedApplicationsForm"
    (ngSubmit)="onSubmitFixedApplications()"
  >
    <div class="columns is-multiline" [ngStyle]="{ 'margin-bottom': '30px' }">
      <div class="column is-2 form-container">
        <span class="label">A3Soc</span>
        <input
          class="search-input"
          type="text"
          pInputText
          formControlName="a3SocCode"
        />
      </div>
      <div class="column is-2 form-container">
        <span class="label">A3Ren</span>
        <input
          class="search-input"
          type="text"
          pInputText
          formControlName="a3RenCode"
        />
      </div>
      <div class="column is-2 form-container">
        <span class="label">A3Nom</span>
        <input
          class="search-input"
          type="text"
          pInputText
          formControlName="a3NomCode"
        />
      </div>
      <div class="column is-2 form-container">
        <span class="label">A3Eco</span>
        <input
          class="search-input"
          type="text"
          pInputText
          formControlName="a3EcoCode"
        />
      </div>
      <div class="column is-2 form-container">
        <span class="label">A3Ges</span>
        <input
          class="search-input"
          type="text"
          pInputText
          formControlName="a3GesCode"
        />
      </div>
      <div class="column is-2">
        <div class="button-container">
          <button class="button save-button is-secondary" type="submit">
            Guardar
          </button>
        </div>
      </div>
    </div>
  </form>

  <div class="form-title-container">
    <h3>Declaraciones contratadas</h3>
    @if (hasEditPermission) {
      <a class="button add-button" (click)="openFormModal()">Añadir contrato</a>
    }
  </div>
  @if (configTable.data) {
    <div class="card">
      <app-clients-table
        [configTable]="activeContractsTableConfig"
        [snapshotMode]="!!snapshotData"
        (close)="close($event)"
        (reopen)="reopen($event)"
        (executeActionEvent)="openExtraTemporaryModal($event)"
        (openItemEvent)="openFormModal($event)"
        (openObservationsEvent)="openObservationsModal($event)"
        (openAvisosEvent)="openAvisosModal($event)"
        (openAllObservationsEvent)="openAllObservationsModal($event)"
      ></app-clients-table>
    </div>
  }

  <!-- <div [formGroup]="declarationsForm" class="declarations">
        <div class="form-title-container">
            <h3>Contratar nueva declaración</h3>
            <a class="button add-button" (click)="addDeclaration()">Añadir declaración</a>
        </div>
        <p-accordion [multiple]="true" formArrayName="declarations">
            @for (declaration of declarations.controls; let i = $index; track declaration) {
                @if(i >= declarationsNumber) {
                    <p-accordionTab header="Nueva Declaración {{i + 1}}" [formGroupName]="i" class="">
                        <div class="columns is-multiline">
                            <div class="column is-6 form-container">
                                <span class="label">Model</span>
                                <p-dropdown
                                [options]="models"                  
                                [group]="true"
                                optionLabel="name"
                                optionValue="id"
                                optionGroupLabel="department"
                                optionGroupChildren="models" 
                                placeholder="Seleccionar modelo" 
                                formControlName="model"
                                (onChange)="availablePresentations($event)"
                                [emptyFilterMessage]="'No se encontraron resultados'"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">Responsable modelo</span>
                                <p-dropdown [options]="" optionLabel="label" placeholder="Seleccionar responsable" formControlName="responsible" [emptyFilterMessage]="'No se encontraron resultados'"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">Ámbito</span>
                                <p-dropdown [options]="clientConstants.AMBITS" optionLabel="label" placeholder="Seleccionar ámbito" formControlName="ambit" [emptyFilterMessage]="'No se encontraron resultados'"/>
                            </div>
                            <div class="column is-6 form-container">
                                <p-checkbox formControlName="specialRegime" binary="true" inputId="specialRegime" />
                                <label for="specialRegime">Régimen especial aplicable</label>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">Descripción régimen especial</span>
                                <input class="search-input" type="text" pInputText formControlName="specialRegimeDescription"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">Periodicidad modelo</span>
                                <p-dropdown [options]="clientConstants.MODEL_PERIODICITY_TYPES" optionLabel="label" placeholder="Seleccionar" formControlName="periodicity" [emptyFilterMessage]="'No se encontraron resultados'"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">Tipo presentación</span>
                                <p-dropdown [options]="presentations"  optionLabel="label" optionValue="value" placeholder="Seleccionar" formControlName="presentationType" [emptyFilterMessage]="'No se encontraron resultados'"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">Cuenta bancaria</span>
                                <p-dropdown [options]="bankAccounts" optionLabel="iban" optionValue="id" placeholder="Seleccionar cuenta bancaria" formControlName="bankAccount" [emptyFilterMessage]="'No se encontraron resultados'"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">Formato fichero</span>
                                <p-dropdown [options]="clientConstants.FORMAT_TYPES" optionLabel="label" optionValue="value" placeholder="Seleccionar" formControlName="format" [emptyFilterMessage]="'No se encontraron resultados'"/>
                            </div>
                            <div class="column is-6 form-container" >
                                <span class="label">Fecha inicio</span>
                                <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="startDate"/>
                            </div>
                            <div class="column is-6 form-container" >
                                <span class="label">Fecha baja</span>
                                <p-calendar [iconDisplay]="'input'" dateFormat="dd/mm/yy" dateFormat="dd/mm/yy" dataType="date" [showIcon]="true" inputId="icondisplay" formControlName="endDate"/>
                            </div>
                            
                            <div class="column is-6 form-container">
                                <span class="label">Contacto origen</span>
                                <input class="search-input" type="text" pInputText formControlName="contact"/>
                            </div>
                            <div class="column is-6 form-container">
                                <span class="label">Programas internos donde darlo de alta</span>
                                <p-dropdown [options]="clientConstants.INTERN_PROGRAMS" optionLabel="label" placeholder="Seleccionar" formControlName="internPrograms"/>
                            </div>
                        </div>
                    </p-accordionTab>
                }
                
            }
        </p-accordion>
    </div> -->
  <div class="modal" [class.is-active]="isDecModalActive">
    <div class="modal-background" (click)="isDecModalActive = false"></div>
    <div class="modal-card">
      <form [formGroup]="modalForm" (ngSubmit)="save()">
        <header class="modal-card-head">
          @if (isCreating) {
            <p class="modal-card-title">Nuevo Contrato</p>
          } @else {
            <p class="modal-card-title">{{ modalForm.value.model.name }}</p>
          }
        </header>
        <section class="modal-card-body">
          @if (isCreating) {
            <div class="field">
              <span class="label">Modelo</span>
              <p-dropdown
                [options]="models"
                [group]="true"
                optionLabel="name"
                optionGroupLabel="department"
                optionGroupChildren="models"
                placeholder="Seleccionar modelo"
                formControlName="model"
                filter="true"
                (onChange)="availablePresentations($event)"
                (ngModelChange)="onModelSelect($event)"
                [emptyFilterMessage]="'No se encontraron resultados'"
                appendTo="body"
              />
            </div>
          }
          <div class="field">
            <span class="label">Tipo presentación - fichero</span>
            <p-dropdown
              [options]="availablePresentationsTypes"
              placeholder="Seleccionar"
              formControlName="presentationType"
              [emptyFilterMessage]="'No se encontraron resultados'"
              appendTo="body"
            />
          </div>
          <div class="field">
            <span class="label">Cuenta bancaria</span>
            <p-dropdown
              [options]="bankAccounts"
              optionLabel="iban"
              optionValue="id"
              [showClear]="true"
              placeholder="Seleccionar cuenta bancaria"
              formControlName="bankAccount"
              [emptyFilterMessage]="'No se encontraron resultados'"
              appendTo="body"
            >
              <ng-template let-option pTemplate="item">
                {{ option.iban | ibanFormat }}
              </ng-template>

              <ng-template let-option pTemplate="selectedItem">
                {{ option.iban | ibanFormat }}
              </ng-template></p-dropdown
            >
          </div>
          <div class="field">
            <span class="label">Responsable</span>
            <p-dropdown
              [options]="filteredUsers"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleccionar responsable"
              formControlName="responsible"
              showClear="true"
              [emptyFilterMessage]="'No se encontraron resultados'"
              appendTo="body"
            />
          </div>
          @if (executors.length > 0) {
            <div class="field" formArrayName="executors">
              <span class="label">Ejecutores</span>
              @for (
                executorControl of executors.controls;
                let j = $index;
                track executorControl
              ) {
                <div class="columns is-multiline is-vcentered">
                  <div class="column is-3">
                    <span class="executor-label"> Fase {{ j + 1 }}</span>
                  </div>
                  <div class="column is-9">
                    <p-dropdown
                      [options]="filteredUsers"
                      optionLabel="name"
                      optionValue="id"
                      placeholder="Seleccionar ejecutor"
                      [formControlName]="j"
                      showClear="true"
                      [emptyFilterMessage]="'No se encontraron resultados'"
                      appendTo="body"
                    >
                    </p-dropdown>
                  </div>
                </div>
              }
            </div>
          }
          <div class="field">
            <label class="label">Fecha alta</label>
            <p-calendar
              [iconDisplay]="'input'"
              dateFormat="dd/mm/yy"
              dataType="date"
              [showIcon]="true"
              inputId="icondisplay"
              formControlName="startDate"
              appendTo="body"
            />
          </div>
          <div class="field">
            <label class="label">Fecha baja</label>
            <p-calendar
              [iconDisplay]="'input'"
              dateFormat="dd/mm/yy"
              dataType="date"
              [showIcon]="true"
              inputId="icondisplay"
              formControlName="endDate"
              appendTo="body"
            />
          </div>
          <div class="field">
            <p-checkbox
              formControlName="executeNextDeclaration"
              binary="true"
              inputId="executeNextDeclaration"
            />
            <label for="executeNextDeclaration"
              >Ejecutar siguiente declaración al dar de baja</label
            >
          </div>
          <!-- <div class="field">
                    <span class="label">Observaciones</span>
                    <textarea pInputTextarea formControlName="observations" rows="3" class="textarea observations-field"></textarea>
                </div> -->
        </section>
        <footer class="modal-card-foot buttons-container">
          <ng-container *ngIf="snapshotData; else decEditButtons">
            <button type="button" class="button cancel-button" (click)="isDecModalActive = false">Cerrar</button>
          </ng-container>
          <ng-template #decEditButtons>
            <button
              class="button cancel-button"
              (click)="isDecModalActive = false"
            >
              Cancelar
            </button>
            <button
              class="button save-button"
              type="submit"
              [disabled]="!modalForm.valid"
            >
              Guardar
            </button>
          </ng-template>
        </footer>
      </form>
    </div>
  </div>

  @if (isExtraTemporaryModalActive) {
    <div class="modal" [class.is-active]="isExtraTemporaryModalActive">
      <div
        class="modal-background"
        (click)="isExtraTemporaryModalActive = false"
      ></div>
      <div class="modal-card">
        <form
          [formGroup]="createExtraTemporaryModalForm"
          (ngSubmit)="createExtraTemporaryDeclaration()"
        >
          <header class="modal-card-head">
            <p class="modal-card-title">
              Crear declaración del modelo
              {{ createExtraTemporaryModalForm.value.model.name }}
            </p>
          </header>
          <section class="modal-card-body">
            <div class="field">
              <label class="label" for="extraTempYear">Año</label>
              <p-calendar
                [iconDisplay]="'input'"
                dateFormat="yy"
                dataType="date"
                [showIcon]="true"
                view="year"
                inputId="extraTempYear"
                formControlName="year"
                appendTo="body"
                [baseZIndex]="4100"
              />
            </div>

            @if (
              createExtraTemporaryModalForm.value.model.periodicity ===
              "TRIMESTRAL"
            ) {
              <div class="field">
                <label class="label" for="extraTempTrimester">Trimestre</label>
                <p-dropdown
                  inputId="extraTempTrimester"
                  [options]="trimesters"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Seleccionar trimestre"
                  formControlName="trimester"
                  appendTo="body"
                  [baseZIndex]="4100"
                />
              </div>
            }
            @if (
              createExtraTemporaryModalForm.value.model.periodicity ===
              "MONTHLY"
            ) {
              <div class="field">
                <label class="label" for="extraTempMonth">Mes</label>
                <p-calendar
                  [iconDisplay]="'input'"
                  dateFormat="mm"
                  dataType="date"
                  [showIcon]="true"
                  view="month"
                  inputId="extraTempMonth"
                  formControlName="month"
                  appendTo="body"
                  [baseZIndex]="4100"
                />
              </div>
            }
            @if (
              createExtraTemporaryModalForm.value.model.periodicity === "PERIOD"
            ) {
              <div class="field">
                <label class="label" for="extraTempPeriod">Período</label>
                <p-dropdown
                  inputId="extraTempPeriod"
                  [options]="
                    createExtraTemporaryModalForm.value.model.customPeriods
                  "
                  placeholder="Seleccionar período"
                  formControlName="period"
                  appendTo="body"
                  [baseZIndex]="4100"
                />
              </div>
            }
            <div class="field checkbox-field" *ngIf="!snapshotData">
              <p-checkbox
                formControlName="generateAtPeriodStart"
                binary="true"
                inputId="generateAtPeriodStartExtraTemporary"
              />
              <label for="generateAtPeriodStartExtraTemporary">Generar al inicio del periodo</label>
            </div>
          </section>
          <footer class="modal-card-foot buttons-container">
            <ng-container *ngIf="snapshotData; else extraTempEditButtons">
              <button type="button" class="button cancel-button" (click)="isExtraTemporaryModalActive = false">Cerrar</button>
            </ng-container>
            <ng-template #extraTempEditButtons>
              <button
                class="button cancel-button"
                (click)="isExtraTemporaryModalActive = false"
              >
                Cancelar
              </button>
              <button
                class="button save-button"
                type="submit"
                [disabled]="!createExtraTemporaryModalForm.valid"
              >
                Crear
              </button>
            </ng-template>
          </footer>
        </form>
      </div>
    </div>
  }
  </div>
}

<!-- Modal de observaciones -->
@if (isObservationsModalActive) {
  <div class="modal" [class.is-active]="isObservationsModalActive">
    <div class="modal-background" (click)="closeObservationsModal()"></div>
    <div class="modal-card">
      <button
        class="modal-close-button"
        (click)="closeObservationsModal()"
        type="button"
      >
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
      <section class="modal-card-body">
        <h3 class="modal-title">
          {{
            observationsModalMode === "readonly"
              ? "Observaciones y Avisos"
              : observationsModalMode === "avisos"
                ? "Avisos"
                : "Observaciones"
          }}
          - {{ currentContractName }} - {{ currentClientName }}
        </h3>
        <!-- Lista de observaciones existentes -->
        <div class="observations-list">
          @if (filteredObservations.length > 0) {
            @for (obs of filteredObservations; track obs.id) {
              <div
                class="observation-item"
                [class.is-notification]="obs.isNotification"
              >
                <div class="observation-header">
                  <div class="observation-info">
                    <strong>{{ obs.user?.name }}</strong>
                    <span class="observation-date">{{
                      obs.created_at | utcDate
                    }}</span>
                    @if (obs.isNotification) {
                      <span class="tag is-warning">Aviso en declaración</span>
                    }
                  </div>
                  @if (
                    observationsModalMode !== "readonly" &&
                    (!obs.isNotification || canDeleteAviso())
                  ) {
                    <button
                      class="delete-observation-btn"
                      (click)="deleteObservation(obs.id)"
                      title="Eliminar observación"
                      type="button"
                    >
                      <fa-icon [icon]="faTrash"></fa-icon>
                    </button>
                  }
                </div>
                <p class="observation-comment">{{ obs.comment }}</p>
              </div>
            }
          } @else {
            <p class="no-observations">
              No hay
              {{
                observationsModalMode === "readonly"
                  ? "observaciones ni avisos"
                  : observationsModalMode === "avisos"
                    ? "avisos"
                    : "observaciones"
              }}
            </p>
          }
        </div>

        <!-- Log de avisos eliminados -->
        @if (observationsModalMode === "avisos" || observationsModalMode === "readonly") {
          <div class="deleted-log-section">
            <button
              class="toggle-deleted-btn"
              type="button"
              (click)="toggleDeletedAvisos()"
            >
              <fa-icon [icon]="showDeletedAvisos ? faChevronUp : faChevronDown" style="margin-right:6px"></fa-icon>
              {{ showDeletedAvisos ? "Ocultar avisos eliminados" : "Ver avisos eliminados" }}
            </button>

            @if (showDeletedAvisos) {
              <div class="observations-list deleted-list">
                @if (deletedAvisos.length > 0) {
                  @for (obs of deletedAvisos; track obs.id) {
                    <div class="observation-item is-deleted">
                      <div class="observation-header">
                        <div class="observation-info">
                          <strong>{{ obs.user?.name }}</strong>
                          <span class="observation-date">{{ obs.created_at | utcDate }}</span>
                          <span class="tag is-deleted">Eliminado el {{ obs.deleted_at | utcDate }}</span>
                        </div>
                      </div>
                      <p class="observation-comment">{{ obs.comment }}</p>
                    </div>
                  }
                } @else {
                  <p class="no-observations">No hay avisos eliminados para este contrato</p>
                }
              </div>
            }
          </div>
        }

        @if (observationsModalMode !== "readonly") {
          <!-- Formulario para añadir nueva observación -->
          <div class="add-observation-section">
            <form [formGroup]="observationForm" (ngSubmit)="addObservation()">
              <div class="field">
                <label class="label"
                  >Añadir
                  {{
                    observationsModalMode === "avisos" ? "aviso" : "observación"
                  }}</label
                >
                <textarea
                  pInputTextarea
                  [autoResize]="true"
                  formControlName="comment"
                  rows="3"
                  class="textarea observations-field"
                  maxlength="500"
                  [placeholder]="
                    observationsModalMode === 'avisos'
                      ? 'Escribe tu aviso...'
                      : 'Escribe tu observación...'
                  "
                ></textarea>
              </div>
              <div class="buttons-container-right">
                <button
                  class="button cancel-button"
                  type="button"
                  (click)="closeObservationsModal()"
                >
                  Cerrar
                </button>
                <button
                  class="button save-button"
                  type="button"
                  (click)="addObservation()"
                  [disabled]="!observationForm.valid"
                >
                  Añadir
                </button>
              </div>
            </form>
          </div>
        } @else {
          <div class="buttons-container-right">
            <!-- <button class="button cancel-button" type="button" (click)="closeObservationsModal()">Cerrar</button> -->
          </div>
        }
      </section>
    </div>
  </div>
}

@if (isSaved) {
  <div class="notification is-success">
    <!-- <button class="delete" (click)="isSaved = false"></button> -->
    <div class="notification-text">
      {{ extraTemporaryFeedbackMessage || 'Declaración creada correctamente.' }}
    </div>
    <div class="progress-bar-container">
      <progress
        class="progress is-small"
        min="0"
        max="100"
        #progressBar
      ></progress>
    </div>
  </div>
}
